import React, { useState } from "react";
import styles from "./SchoolFaq.module.css";
import { Minus, Plus } from "lucide-react";

import RichText from "../RichText/RichText";

interface CMSFAQ {
  id?: number;
  title: string;
  description: string;
}

interface SchoolFaqProps {
  Data?: {
    title?: string;
    questions?: CMSFAQ[];
  };
}

const SchoolFaq: React.FC<SchoolFaqProps> = ({ Data }) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const title = Data?.title || "Frequently Asked Questions";
  const questions = Data?.questions || [];

  return (
    <div className="container">
      <div className={styles.faqContainer}>
        <h2 className={styles.heading}>{title}</h2>
        <div className={styles.faqList}>
          {questions.map((item, index) => (
            <div
              key={item.id || index}
              className={`${styles.faqItem} ${
                activeIndex === index ? styles.active : ""
              }`}
              onClick={() => toggleFaq(index)}
            >
              <div className={styles.faqQuestion}>
                <h3>{item.title}</h3>
                <span className={styles.icon}>
                  {activeIndex === index ? <Minus /> : <Plus />}
                </span>
              </div>
              {activeIndex === index && (
                <div className={styles.faqAnswer}>
                  {item.description && <RichText data={item.description} />}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SchoolFaq;
